import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'showFeaturedLabel',
    standalone: false
})
export class FeaturedLabelPipe implements PipeTransform {
	transform(profile: any): any {
		return profile.promotion_locations?.some(location => location.label);
	}
}
